import { jsx } from "react/jsx-runtime";
import { format } from "date-fns";
import es from "date-fns/locale/es";
const formatDate = (date, fmt = 'PPP')=>format(date, fmt, {
        locale: es
    });
const useDateInputLabel = ({ selected, placeholder, onMaskValue, mode })=>{
    const placeholderJsx = /*#__PURE__*/ jsx("span", {
        className: "tw-text-neutral-light-500",
        children: placeholder || '00/00/00 - 00/00/00'
    });
    if (!selected) return placeholderJsx;
    if (onMaskValue) return onMaskValue(selected);
    if ('single' === mode) return formatDate(selected);
    const { from, to } = selected;
    const rangeFmt = 'dd/MM/y';
    if (from && to) return `${formatDate(from, rangeFmt)} - ${formatDate(to, rangeFmt)}`;
    if (from) return `${formatDate(from, rangeFmt)}`;
    return placeholderJsx;
};
export { useDateInputLabel };
